import React from 'react';
import UpdateDeliveryOrdersStatusButtonProperties from "./UpdateDeliveryOrdersStatusButtonProperties";
import {useI18nContext} from "../../../contexts/I18nContext";
import UpdateDeliveryOrdersStatusStore from "./UpdateDeliveryOrdersStatusStore";
import RoundedButton from "../../../ui_components/RoundedButton/RoundedButton";
import Modal from "../../../ui_components/Modal/Modal";
import {Observer} from "mobx-react-lite";
import {useStyles} from "./UpdateDeliveryOrdersStatusButton.style";
import Button from "../../../ui_components/Button/Button";
import ButtonType from "../../../ui_components/Button/ButtonType";
import {useCommonContext} from "../../../contexts/CommonContext";
import ButtonSize from "../../../ui_components/Button/ButtonSize";
import ProductOrderStatusSelect from '../../Selects/ProductOrderStatusSelect/ProductOrderStatusSelect';
import CommentInput from '../../Inputs/CommentInput/CommentInput';
import useOnEnterPress from '../../../hooks/EnterPress';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';

const UpdateDeliveryOrdersStatusButton: React.FC<UpdateDeliveryOrdersStatusButtonProperties> = ({
                                                                                onClick = () => {
                                                                                },
                                                                                onSave = () => {
                                                                                },
                                                                                showIcon = true,
                                                                                showText = true,
                                                                                disabled,
                                                                                className = '',
                                                                                rounded = false,
                                                                                size = ButtonSize.DEFAULT,
                                                                                type = ButtonType.DEFAULT,
                                                                                deliveryOrderType,
                                                                                productOrderIds
                                                                            }) => {
    const classes = useStyles(showText);
    const i18n = useI18nContext();
    const commonContext = useCommonContext();
    const store = new UpdateDeliveryOrdersStatusStore(commonContext, productOrderIds, deliveryOrderType);

    const handleOnclick = async () => {
        await store.openModal();
        onClick();
    }

    const onCloseModal = () => {
        store.closeModal();
    }
    
    const onCommentChange = (newComment: string) => (store.comment = newComment);
    const onStatusChange = (option: string) => {
       store.status = option;
    }

    const onOrderStatusSave = async () => {
        const saved = await store.save();
        if (saved) {
            store.closeModal();
            if (onSave) {
                onSave();
            }
        }
    }
    useOnEnterPress(onSave,[store]);
    
    const Icon = PlaylistAddCheckIcon;
    const Btn = () => {
        if (rounded) {
            return <RoundedButton
                onClick={handleOnclick}
                className={className}
                disabled={disabled}
                tooltip={!showText ? 'Entregar' : ""}
                text={showText ? 'Entregar' : ""}
                type={type}
                icon={showIcon ? 'Entregar' : <></>}
            />  
        }
        return <Button
            text={showText ? 'Entregar' : ""}
            className={className}
            tooltip={!showText ? 'Entregar' : ""}
            disabled={disabled}
            size={size}
            onClick={handleOnclick}
            type={type}
            startIcon={showIcon ? <Icon/> : <></>}
        />
    }
    return <Observer>
        {() => (
            <>
                <Modal fullScreen={false} loading={store.loading} title={'Entregar'} onClose={onCloseModal} open={store.isModalOpen}>
                    <div className={classes.modal_container}>
                        <ProductOrderStatusSelect fullWidth selected={store.status} onChange={onStatusChange} disabled={true}/>
                        <CommentInput
                            fullWidth
                            lines={3}
                            onChange={onCommentChange}
                            value={store.comment}
                            className={classes.input}/>
                        <Button
                            disabled={!store.enableButton}
                            loading={store.loading} className={classes.input} onClick={onOrderStatusSave}
                            type={ButtonType.SECONDARY}
                            text={i18n.translate("SAVE")}/>
                    </div>
                </Modal>
                <Btn/>
            </>
        )}
    </Observer>
}

export default UpdateDeliveryOrdersStatusButton;
